import mwrHttp from '@/utils/activityHttp'
import store from '@/store'

const isDev = process.env.VUE_APP_ENV === 'dev'
let accountBasePath = isDev
  ? '/minifire_account_server_os/api/v1'
  : 'https://wapi.miniworldplus.com:1443/minifire_account_server_os/api/v1'

if (process.env.VUE_APP_ENV === 'prod') {
  accountBasePath = 'https://wapi.miniworldgame.com/minifire_account_server_os/api/v1'
}

const commitActUser = (res) => {
  store.commit('SET_ACT_USER_INFO', {
    token: res.authorization,
    expireAt: res.expireAt,
    ...res.roleInfo,
  })
}

export default {
  gameTokenLogin: async (params) => {
    try {
      const res = await mwrHttp.post(`${accountBasePath}/game/gameTokenLogin`, params)
      commitActUser(res)
    } catch (error) {
      console.error(error)
    }
    location.href = location.origin + location.pathname
  },
  loginByMailCode: async (params) => {
    const res = await mwrHttp.post(`${accountBasePath}/game/gameMailLogin`, params)
    commitActUser(res)
    return res
  },
  sendMailCode: (params) => {
    return mwrHttp.post(`${accountBasePath}/game/sendGameMailVerifyCode`, params)
  },
}
